module.exports = __webpack_public_path__ + "img/accomplish.50354390.png";